import React from 'react'
import { useState, useEffect } from 'react'
import { Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import secureLocalStorage from 'react-secure-storage'
import CardQuickGuide from './CardQuickGuide'
import CardHomeTeacherLink from '../components/CardHomeTeacherLink'
import CardTeacherLink from '../components/CardTeacherLink'

import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined'
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined'
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined'
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined'
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined'

import AttachmentService from '../../services/AttachmentService'

export default function HomeAreaManager() {
  const { t } = useTranslation()

  const localPermissions = secureLocalStorage
    .getItem('permissions')
    ?.toString()
  const permissions = localPermissions?.split(',')

  const [url, setUrl] = useState('')

  const feature = 'quickguide'
  const idGuide = 2 //id do perfil coordenador, porque o manual é o mesmo p/ gestor
  const name = 'manual_hiplade_coordinator' // nome de campo do perfil coodenador

  const getFile = async () => {
    await AttachmentService.get(feature, idGuide, name)
      .then((response) => {
        if (response.data.length > 0) {
          setUrl(response.data[0].url)
        }
      })
      .catch(() => {})
  }

  useEffect(() => {
    if (idGuide) {
      getFile()
    }
  }, [])

  const openQuickGuide = url
    ? () => window.open(url, '_blank', 'noopener,noreferrer')
    : undefined

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <CardQuickGuide
          title={t('btn_quick_guide')}
          subtitle={t('subtitle_quick_guide')}
          icon={<FindInPageOutlinedIcon />}
          onClick={openQuickGuide}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CardHomeTeacherLink
          title={t('btn_prepare_events')}
          subtitle={t('subtitle_prepare_events')}
          path="/events/area"
          icon={<AnalyticsOutlinedIcon />}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CardTeacherLink
          title={t('btn_create_new_events')}
          subtitle={t('subtitle_create_new_events')}
          path="/events/form"
          icon={<AddBoxOutlinedIcon />}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CardTeacherLink
          title={t('btn_ongoing_events')}
          subtitle={t('subtitle_ongoing_events')}
          path="/events/schedule/2"
          icon={<VideocamOutlinedIcon />}
        />
      </Grid>
      {permissions?.includes('read_event') && (
        <Grid item xs={12} md={6}>
          <CardTeacherLink
            title={t('btn_student_schedule')}
            subtitle={t('subtitle_student_schedule')}
            path="/events/schedule"
            icon={<TodayOutlinedIcon />}
          />
        </Grid>
      )}
    </Grid>
  )
}
